import React from 'react';
import Accordion from '@Components/Accordion/Accordion';
import Divider from '@Components/Divider/Divider';
import useTranslate from '@Utils/hooks/useTranslate';
import { DividerWrapper } from '@Components/Card/cards/ShippingDetails/ShippingDetails.styled';

interface IDigitalDelivery {
	subtitle: string;
}

const DigitalDelivery = ({ subtitle }: IDigitalDelivery): JSX.Element => {
	const { translate } = useTranslate();
	return (
		<>
			<DividerWrapper>
				<Divider />
			</DividerWrapper>
			<Accordion
				title={translate('shipping-details.accordion.digital-shipping-data.title')}
				subtitle={subtitle}
				icon="messages"
				displayExpand={false}
			/>
		</>
	);
};

export default DigitalDelivery;
